"use strict";
'use client';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var swr_hooks_1 = require("@l2p/swr-hooks");
var ui_components_1 = require("@l2p/ui-components");
var InputSwitchButton_1 = __importDefault(require("@l2p/ui-components/src/Inputs/InputSwitchButton"));
var next_intl_1 = require("next-intl");
var react_1 = __importStar(require("react"));
var MobileRow_1 = __importDefault(require("./MobileRow"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var useMobileData_1 = require("./useMobileData");
var useStatusOptions_1 = require("./useStatusOptions");
var useTableData_1 = require("./useTableData");
var ITEMS_PER_PAGE = 20;
var TransactionsList = function () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    var t = (0, next_intl_1.useTranslations)('translation');
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    var OPTION_ALL = (0, react_1.useMemo)(function () { return ({ label: t('all'), value: 'all' }); }, [t]);
    var _k = (0, react_1.useState)(false), mounted = _k[0], setMounted = _k[1];
    var _l = (0, react_1.useState)({ from: undefined, to: undefined }), dates = _l[0], setDates = _l[1];
    var _m = (0, react_1.useState)(OPTION_ALL), status = _m[0], setStatus = _m[1];
    var _o = (0, react_1.useState)(OPTION_ALL), type = _o[0], setType = _o[1];
    var _p = (0, swr_hooks_1.useGetTransactionsHistory)({
        count: ITEMS_PER_PAGE,
    }), data = _p.data, isSubmitting = _p.isSubmitting, loadTransactionsByFilter = _p.loadTransactionsByFilter, loadMore = _p.loadMore;
    var searchPayload = (0, react_1.useMemo)(function () {
        return {
            filter: {
                type: (type === null || type === void 0 ? void 0 : type.value) && (type === null || type === void 0 ? void 0 : type.value) !== 'all'
                    ? type === null || type === void 0 ? void 0 : type.value
                    : undefined,
                status: (status === null || status === void 0 ? void 0 : status.value) && (status === null || status === void 0 ? void 0 : status.value) !== 'all'
                    ? status === null || status === void 0 ? void 0 : status.value
                    : undefined,
            },
            dateRange: {
                from: dates === null || dates === void 0 ? void 0 : dates.from,
                to: dates === null || dates === void 0 ? void 0 : dates.to,
            },
        };
    }, [type, status, dates === null || dates === void 0 ? void 0 : dates.from, dates === null || dates === void 0 ? void 0 : dates.to]);
    (0, react_1.useEffect)(function () {
        loadTransactionsByFilter(searchPayload);
        //eslint-disable-next-line
    }, [searchPayload]);
    var loadMoreHandler = (0, react_1.useCallback)(function () {
        loadMore(searchPayload);
    }, [loadMore, searchPayload]);
    var loadTransactionsByFilterHandler = (0, react_1.useCallback)(function () {
        loadTransactionsByFilter(searchPayload);
    }, [loadTransactionsByFilter, searchPayload]);
    var transactionsData = ((_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.transaction) === null || _b === void 0 ? void 0 : _b.get) === null || _c === void 0 ? void 0 : _c.edges) || [];
    var statusOptions = (0, useStatusOptions_1.useStatusOptions)();
    var transactionStatuses = (0, apps_shared_1.useGenerateTransactionStatuses)();
    var tableData = (0, useTableData_1.useTableData)(transactionsData, loadTransactionsByFilterHandler);
    var mobileTableData = (0, useMobileData_1.useMobileData)(transactionsData, loadTransactionsByFilterHandler);
    var onDateFilterChange = (0, react_1.useCallback)(function (dates) { return setDates(dates); }, []);
    (0, react_1.useEffect)(function () {
        setMounted(true);
    }, []);
    //
    if (!mounted)
        return react_1.default.createElement(react_1.default.Fragment, null);
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        Object.keys(breakpoints).length > 0 && !breakpoints.mobile && (react_1.default.createElement("div", { className: styles_module_scss_1.default.filtersWrapper },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.filtersContainer },
                react_1.default.createElement(InputSwitchButton_1.default, { options: __spreadArray([OPTION_ALL], transactionStatuses, true), value: type, onChange: function (value) { return setType(value); } }),
                react_1.default.createElement(ui_components_1.InputSelectSecondary, { inputName: "status", options: __spreadArray([OPTION_ALL], statusOptions, true), value: status, onChange: function (value) { return setStatus(value); }, isSearchable: false })),
            react_1.default.createElement(ui_components_1.DatePickerRangeWithIcon, { onChange: onDateFilterChange, values: dates }))),
        Object.keys(breakpoints).length > 0 && breakpoints.mobile && (react_1.default.createElement("div", { className: styles_module_scss_1.default.filtersWrapper },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.filtersContainerMobile },
                react_1.default.createElement(ui_components_1.InputSelectSecondary, { inputName: "status", options: __spreadArray([OPTION_ALL], statusOptions, true), value: status, onChange: function (value) { return setStatus(value); }, isSearchable: false }),
                react_1.default.createElement(ui_components_1.DatePickerRangeWithIcon, { onChange: onDateFilterChange, values: dates })),
            react_1.default.createElement(InputSwitchButton_1.default, { options: __spreadArray([OPTION_ALL], transactionStatuses, true), value: type, onChange: function (value) { return setType(value); } }))),
        !data && isSubmitting ? (react_1.default.createElement(ui_components_1.LoadingWithContainer, null)) : (react_1.default.createElement(react_1.default.Fragment, null,
            Object.keys(breakpoints).length > 0 &&
                !breakpoints.mobile &&
                !breakpoints.tablet && (react_1.default.createElement(ui_components_1.TableDataWithPagination, { data: tableData, totalCount: (_f = (_e = (_d = data === null || data === void 0 ? void 0 : data.data) === null || _d === void 0 ? void 0 : _d.transaction) === null || _e === void 0 ? void 0 : _e.get) === null || _f === void 0 ? void 0 : _f.totalCount, loadMoreClick: loadMoreHandler, loading: isSubmitting })),
            Object.keys(breakpoints).length > 0 &&
                (breakpoints.mobile || breakpoints.tablet) && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("br", null),
                react_1.default.createElement(ui_components_1.MobileDataTableWithPagination, { data: mobileTableData, rowComponent: MobileRow_1.default, totalCount: (_j = (_h = (_g = data === null || data === void 0 ? void 0 : data.data) === null || _g === void 0 ? void 0 : _g.transaction) === null || _h === void 0 ? void 0 : _h.get) === null || _j === void 0 ? void 0 : _j.totalCount, loadMoreClick: loadMoreHandler, loading: isSubmitting })))))));
};
exports.default = TransactionsList;
